export default [
  {
    path: '/main/api-geocode-engine',
    meta: {
      tag: 'api-geocode-engine',
      name: 'Engine Geocode/RevGeocode',
      breadcrumb: 'Engine Geocode/RevGeocode',
      menu: 'settings'
    },
    component: () => import(/* webpackChunkName: "engine-geocode" */ '@/views/main/settings/app-frotix-registers/enginegeocode/Add.vue')
  }
]
